import React from "react";
import { Button } from "@mui/material";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import styles from "@/src/styles/home.module.css";

function SendResultSection(props: { title?: string }) {
  return (
    <Box sx={{ py: 0, padding: "60px 0 0" }}>
      <Container maxWidth={false} className={"containerWidth"}>
        <div className={styles.sendResultBox}>
          <h1 className={styles.sendResultTitle}>
            Lorem ipsum dolor sit amet, consectetur
          </h1>
          <div className={styles.sendResultText}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
            do eiusmod tempor. <br />
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed.
          </div>
          <div className={styles.sendResultButton}>
            <Button
              variant="contained"
              sx={{
                width: "200px",
                height: "50px",
                boxShadow: "none",
                backgroundColor: "#3f3f3f",
                fontSize: "15px",
                fontWeight: 600,
                borderRadius: "8px",
                textTransform: "none",
                "&.MuiButtonBase-root:hover": {
                  backgroundColor: "#878b93",
                },
              }}
            >
              VIEW
            </Button>
          </div>
        </div>
      </Container>
    </Box>
  );
}

export default SendResultSection;
